import React, { useState } from 'react';
import "./Sec1Home.css"
import HomeImg from '../../Images/blog-banner.jpg'
import Facebook from '../../Images/facebook.png'
import Twitter from '../../Images/twitter.png'
import Linkedin from '../../Images/linkedin.png'
import Arrow from '../../Images/Arrow<.png'



import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

function Sec1Home() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="sec1home-container container">
      <div className="sec1home-content">
      {/*<div className='NewBlog'>
         <img src={Arrow}></img>
          <p>Back to New Blog</p> 
        </div> */}
        <h1 className="sec1home-title">INDIA’S GLOBAL LEAP WHY GLOBAL ORGANIZATIONS SET UP GLOBAL CAPABILITY CENTERS IN INDIA?</h1>
        <div className='social-links-container'>
            <a href='https://x.com/zinnov'className='social-links twitter'><img src={Twitter} alt="Twitter" /></a>
            <a href='https://www.linkedin.com/company/zinnov' className='social-links linkedin'><img src={Linkedin} alt="Linkedin" /></a>
            <a href='https://www.facebook.com/ZinnovManagementConsulting' className='social-links facebook'><img src={Facebook} alt="Facebook" /></a>
        </div>
        <div className="sec1home-image-container">
            <img src={HomeImg} alt='GCC in India' className="sec1home-image" preload="auto" />
        </div>
        <p className="sec1home-paragraph text">In the last 2 years, <b>India has seen 110+ new GCCs set up, bringing the total number of GCCs in the country to 2,117, collectively employing more than 2.36 Mn professionals.</b> This growth has come at a time when the world is facing geopolitical and macroeconomic challenges, with global organizations seeking a safe and stable haven for their operations. </p>

        <AudioPlayer
          className='audio'
          showJumpControls={true}
          customAdditionalControls={[]}
          src="https://zinnov.s3.us-east-2.amazonaws.com/policy/why-set-up-global-capability-centers-in-india-blog.c2707865-4f7b-4c65-97b6-7db2c3aac1c2.mp3"
          layout="horizontal"
        />

        <p className="sec1home-paragraph text">In 1985, Texas Instruments did something that no other organization had done before – they set up <a href="https://www.forbesindia.com/article/leadership/indian-gccs-and-the-talent-landscape/95408/1" target="_blank" rel="noreferrer nofollow" >Global Capability Center (GCC)</a> or an offshore center in India, sparking a trend. Though little-known today, it was an inflection point that set change in motion.</p>

        <div id='grid-sec1'>
          <div id="authors-section">
            <div id="author-details">
              <div className='closed'>
                <h5 id="authors-title">Authors</h5>
                <div class='author-icon-block' onClick={toggleExpand}>
                  <span style={{ marginTop: isExpanded ? '-2px' : '0' }}>
                    {isExpanded ? '-' : '+'}
                  </span>
                </div>
              </div>
              {isExpanded && (
                <>
                  <span className="author" id="author-1">
                    <a className="author-name" href='https://zinnov.com/nitika-goel/' target='_blank'>Nitika Goel</a>
                    <p className="author-title authortext" style={{ color: '#939393' }}>Chief Marketing Officer</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>Zinnov</p>
                  </span>

                  <span className="author" id="author-2">
                    <p className="author-name">Sachit Bhat</p>
                    <p className="author-title authortext" style={{ color: '#939393' }}>Associate</p>
                    <p className="author-company authortext" style={{ color: '#939393' }}>Zinnov</p>
                  </span>
                </>
              )}
            </div>
            <div id='tag'>
              <a className='tags' href='https://zinnov.com/offerings/gcc-setup-and-transformation/' target='_blank'>GLOBAL CAPABILITY CENTER SETUP</a>
              <a className='tags' href='https://zinnov.com/offerings/global-coe-accelerator-platform/' target='_blank'>GCC PLATFORM</a>
              <a className='tags' href='https://zinnov.com/offerings/gcc-setup-and-transformation/gcc-managed-services/' target='_blank'>GCC MANAGED SERVICES</a>
              <a className='tags' href='https://zinnov.com/offerings/gcc-setup-and-transformation/center-transformation/' target='_blank'>CENTER TRANSFORMATION</a>
            </div>
          </div>
            
          <p className="sec1home-paragraph text">The ‘90s rolled in, and India opened its door to the world. Many other big names like IBM, Accenture, and Microsoft started thinking, “Hey, maybe we should try offshoring, too.” Attracted by the promise of cost savings, they arrived with expectations of efficiency but were met with something far more valuable: a wealth of talent eager to prove its worth. The world’s largest democracy became synonymous with abundantly talented knowledge professionals, world-class engineering intellect, and business expertise.</p>
        </div>
        <p className="sec1home-paragraph text">Today over 2000 maturing GCCs drive global transformation showcasing India’s immense service delivery capabilities. <a href="https://yourstory.com/enterprise-story/2025/05/8-reasons-why-mncs-setting-up-gccs-india-zinnov" target="_blank" rel="noreferrer nofollow">From cost to resilience: 8 reasons why MNCs are rushing to set up GCCs in India | YourStory why set up a Global Capability Center in India and what motivates increasing MNCs to join the ranks by adding offshore captive centers in India year on year?</a></p>
      </div>
    </div>
  );
}

export default Sec1Home;
